export default __webpack_public_path__ + "static/media/drag-icon.601b68f9.svg";